import { ReactComponent as ArrowIcon } from '../../assets/icons/arrow_left.svg';
import { useNavigate } from 'react-router';
import { useCallback } from 'react';
import AttendanceChallengeBoard from '../../components/attendance/AttendanceChallengeBoard';
import { useAttendanceClaim } from '../../components/attendance/useAttendanceClaim';
import { useAttendanceInfo } from '../../hooks/useAttendanceInfo';
import { useToast } from '../../context/ToastContext';

const ALERT_TIMEOUT = 2000;

function AttendanceHeader({ onBack }) {
  return (
    <div className="relative flex h-12 items-center justify-center bg-white">
      <ArrowIcon className="absolute left-6 cursor-pointer" onClick={onBack} />
      <h3 className="font-['Pretendard'] text-lg font-bold text-black">출석체크</h3>
    </div>
  );
}

export default function AttendancePage() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { data, mutate } = useAttendanceInfo();
  const showAttendanceToast = useCallback(
    (message) => {
      showToast(message, { timeout: ALERT_TIMEOUT });
    },
    [showToast],
  );
  const { onCta, busy } = useAttendanceClaim({
    data,
    mutate,
    onToast: showAttendanceToast,
  });
  const goBack = () => navigate('/playground');

  if (!data || data.result !== 'ok') {
    return (
      <section className="min-h-screen bg-background01">
        <AttendanceHeader onBack={goBack} />
      </section>
    );
  }

  return (
    <section className="min-h-screen bg-white">
      <AttendanceHeader onBack={goBack} />
      <AttendanceChallengeBoard data={data} onCta={onCta} busy={busy} />

      <div className="bg-white px-[15px] pb-10 pt-6">
        <h4 className="font-['Pretendard'] text-base font-bold tracking-[-0.3px] text-black">참여 Tips</h4>
        <ol className="mt-2 list-decimal space-y-0 pl-6 font-['Pretendard'] text-base font-medium leading-[1.6] tracking-[-0.3px] text-gray04">
          <li>출석은 매일 자정(00:00) 초기화</li>
          <li>14일 완주 시 1일차부터 새로 시작</li>
          <li>놓친 출석은 광고 시청 후 이어서 참여 가능</li>
        </ol>
      </div>
    </section>
  );
}
